import type { HttpApiError } from '@backmarket/http-api'
import { getReferral } from '@backmarket/http-api/src/api-specs-user-lifecycle/promotion-codes/promotion-codes'
import type { GetReferralApiResponse } from '@backmarket/http-api/src/api-specs-user-lifecycle/promotion-codes/promotion-codes.types'
import { $httpFetch } from '@backmarket/nuxt-module-http/$httpFetch'
import { useSWRAsyncData } from '@backmarket/nuxt-module-http-v2/useSWRAsyncData'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

import { LOG_ERROR_MESSAGE } from './ReferAFriend.constants'
import { getErrorType, getHttpErrorStatusCode } from './utils/errorUtils'

type GetReferralResponse =
  | (GetReferralApiResponse & {
      hasPromoCode: true
    })
  | {
      hasPromoCode: false
    }
export function useReferAFriend() {
  return useSWRAsyncData<GetReferralResponse>('refer-a-friend', async () => {
    try {
      const apiResponse = await $httpFetch(getReferral)

      return { ...apiResponse, hasPromoCode: !!apiResponse.referralCode }
    } catch (err) {
      const error = err as HttpApiError

      // 404 = user has no promo code (valid state, no log needed)
      if (error.status === 404) return { hasPromoCode: false }

      // Log all other errors (500, 429, network, etc.)
      const logger = useLogger()
      const httpErrorStatusCode = getHttpErrorStatusCode(err)
      const errorType = getErrorType(httpErrorStatusCode)

      logger.error(LOG_ERROR_MESSAGE.FETCH_REFERRAL, {
        error,
        feature: 'refer-a-friend',
        refer_friend_action: 'fetch_referral',
        api_endpoint: '/bm/client/referrals/referrer',
        error_type: errorType,
        error_status: httpErrorStatusCode,
        owners: ['bot-squad-lifecycle-front'],
      })

      throw error
    }
  })
}
